import React, { Component } from "react";
//import { Link } from "react-router-dom";
import Fuse from "fuse.js";
import Icon from "../Icon";
import ArrowNav from "react-arrow-nav";
import { formatUrl } from "../../util/format-url";

const options = {
  includeScore: true,
  shouldSort: true,
  minMatchCharLength: 2,
  // threshold: 0.6,
  keys: ["name"],
};

interface Props {
  pages: any;
  selectSearch: (name: string, content: any) => void;
}

interface State {
  searchTerm: string;
  searchResults: any;
  menuItems: any;
  isFocused: boolean;
}

class Search extends Component<Props, State> {
  state = {
    searchTerm: "",
    searchResults: [],
    menuItems: [],
    isFocused: false,
  };
  componentDidMount() {
    var menuItems: any = [];
    var pages: any = this.props.pages;
    pages.forEach((group: any) => {
      if (group.items) {
        group.items.forEach((menuItem: any) => {
          menuItems.push(menuItem);
        });
      }
    });
    this.setState({
      menuItems: menuItems,
    });
  }
  handleSearch(e: any) {
    let searching: string = e.target.value;
    this.setState(
      {
        searchTerm: searching,
      },
      () => {
        const fuse = new Fuse(this.state.menuItems, options);
        const result = fuse.search(searching);
        var tempResults: any = [];
        if (result && result.length > 0) {
          result.forEach((r: any) => {
            if (r.item.name && r.item.menu_group) {
              var tempItem: any = {
                url: `/${formatUrl(r.item.menu_group.name)}/${formatUrl(
                  r.item.name
                )}`,
                name: r.item.name,
                content: "",
              };
              tempResults.push(tempItem);
            }
          });
        }
        this.setState({
          searchResults: tempResults,
        });
      }
    );
  }
  selectSearchItem(url: string, name: string, content: string) {
    //this.props.selectSearch(name, content);
    const winUrl: any = window.location;
    document.location.href = `${winUrl.origin}${url}`;
    this.setState({
      searchTerm: "",
      searchResults: [],
    });
  }
  handleSearchOnEnterKeyPress = (e: any, url: string) => {
    if (e.key === "Enter") {
      const winUrl: any = window.location;
      document.location.href = `${winUrl.origin}${url}`;
      this.setState({
        searchTerm: "",
        searchResults: [],
      });
    }
  };
  handleSearchKeyDown = (e: any) => {
    if (e.key === "ArrowDown") {
      //this.setState({ navigateSuggestions: true });
      let firstSuggestion: HTMLElement | null =
        document.getElementById("suggestion-0")!;
      if (firstSuggestion) {
        firstSuggestion.focus();
      }
    }
  };

  handleFocus = () => {
    this.setState({isFocused: true});
  };

  handleBlur = (e:React.FocusEvent) => {
    if (
      !e.relatedTarget ||
      !(e.relatedTarget as HTMLElement).classList.contains("search-link")) {
      this.setState({ isFocused: false });
    }
  };

  render() {
    var {searchTerm, searchResults, isFocused} = this.state;
    return (
      <div className="search">
        <div className="search-input">
          <Icon name="search" />
          <input
            type="text"
            placeholder="Search..."
            onChange={(e: any) => this.handleSearch(e)}
            onKeyDown={(e: any) => this.handleSearchKeyDown(e)}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            value={searchTerm}
          />
        </div>
        {isFocused && searchResults && searchResults.length > 0 && (
          <div className="search-results">
            <ArrowNav className="arrowNavHolder">
              {searchResults.map((rItem: any, ind: number) => {
                return (
                  <div
                    id={"suggestion-" + ind}
                    key={`search-link-${rItem.url}`}
                    className="search-link"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() =>
                      this.selectSearchItem(
                        rItem.url,
                        rItem.name,
                        rItem.content
                      )
                    }
                    onKeyPress={(e: any) =>
                      this.handleSearchOnEnterKeyPress(e, rItem.url)
                    }
                    tabIndex={-1}
                  >
                    <input
                      type="text"
                      className="hiddenInputField"
                      value={rItem.name}
                      onKeyPress={(e: any) =>
                        this.handleSearchOnEnterKeyPress(e, rItem)
                      }
                      readOnly
                    />
                    {rItem.name}
                  </div>
                );
              })}
            </ArrowNav>
          </div>
        )}
      </div>
    );
  }
}

export default Search;
